<div class="page-body">
    <h1>Редактор формул VizExMathType</h1>
    <p>
        Редактор формул предназначен для быстрого набора и вставки формул, уравнений или отдельных
        символов и выражений в поле ввода веб-страницы.
    </p>
    <h3>Программное обеспечение «Редактор формул VizExMathType», это:</h3>
    <ul>
        <li>
            Возможность пользователю создавать и редактировать различные формулы и уравнения в поле
            ввода различных веб-страниц.
        </li>
        <li>
            Упрощение процесса ввода математических, химических, физических и др. видов формул и
            уравнений в браузере.
        </li>
        <li>
            Возможность пользователю использовать систему ввода и отрисовки формул в поле ввода и
            визуализированный модуль-подсказку для пользователей, в котором отображаются графические
            пиктограммы для быстрого ввода желаемых функций без знания точного текстового
            обозначения.
        </li>
        <li>Возможность работать с любым web-редактором, через API-протокол.</li>
    </ul>
    <h3>Программное обеспечение «Редактор формул VizExMathType»</h3>
    <img
        src="assets/vr/vizexmathtype/screenshots/1.jpg
    "
    />
    <img
        src="assets/vr/vizexmathtype/screenshots/2.jpg
    "
    />
    <img
        src="assets/vr/vizexmathtype/screenshots/3.jpg
    "
    />
    <img src="assets/vr/vizexmathtype/screenshots/4.png" />
    <img src="assets/vr/vizexmathtype/screenshots/5.png" />
    <img src="assets/vr/vizexmathtype/screenshots/6.png" />
    <h3>Пользовательская документация</h3>
    <a href="assets/vr/vizexmathtype/Инструкция по установке «Редактор формул».pdf" download
        >Инструкция по установке</a
    >
    <a href="assets/vr/vizexmathtype/Лицензионное_соглашение_«Редактор_формул».pdf" download
        >Лицензионное соглашение</a
    >
    <a href="assets/vr/vizexmathtype/Руководство пользователя «Редактор формул».pdf" download
        >Руководство пользователя</a
    >
</div>
